import { render } from "./HelpText.vue?vue&type=template&id=05b33a74"
import script from "./HelpText.vue?vue&type=script&lang=js"
export * from "./HelpText.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HelpText.vue"]])

export default __exports__